import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
import { compose } from 'redux';
import { DialogContent, FormHelperText } from '@mui/material';
import { PubSub } from '../../utils/eventUtils';

import { deleteNaicsCode } from '../../naics/NaicsService';
import { withToggleModal } from '../hocs/withToggleModal';

class NaicsCodeDeleteConfirm extends Component {
  subscription: any;

  constructor(props: any) {
    super(props);
    this.state = {
      naicsCode: '',
      error: '',
    };
  }

  componentDidMount() {
    const {
      // @ts-expect-error TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      props: { data },
    } = this;

    this.setState({
      id: data.id,
      naicsCode: data.naicsCode,
    });
    this.subscription = PubSub.subscribe(
      'foot-button-one',
      (eventData: any) => {
        if (eventData) {
          this.handleSubmit();
        }
      }
    );
  }

  handleSubmit = () => {
    PubSub.publish('loading', true);
    PubSub.publish('disabled', true);
    deleteNaicsCode({
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
      id: this.state.id,
    })
      .then(() => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        // @ts-expect-error TS(2339): Property 'toggleModal' does not exist on type 'Rea... Remove this comment to see the full error message
        this.props.toggleModal.direct('NaicsCodeDeleteConfirm', false);
        // @ts-expect-error TS(2339): Property 'enqueueSnackbar' does not exist on type ... Remove this comment to see the full error message
        this.props.enqueueSnackbar('Industry Code Deleted Successfully!', {
          variant: 'success',
        });
        PubSub.publish('table-refetch', 'naicsCodes');
      })
      .catch((error: any) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.setState({ error: error.response.data });
      });
  };

  render() {
    return (
      <DialogContent>
        <div className="modal-title">
          You are about to remove the Industry Code -
          {/* @ts-expect-error TS(2339): Property 'naicsCode' does not exist on type 'Reado... Remove this comment to see the full error message */}
          <span className="modal-blue-text"> {this.state.naicsCode}</span>.
          <p style={{ margin: 0 }}>Are you sure you want to delete it?</p>
        </div>
        <FormHelperText className="api-text-error">
          {/* @ts-expect-error TS(2339): Property 'error' does not exist on type 'Readonly<... Remove this comment to see the full error message */}
          {this.state.error}
        </FormHelperText>
      </DialogContent>
    );
  }
}

export default compose(withSnackbar, withToggleModal)(NaicsCodeDeleteConfirm);
